import { escapeHtml } from "../escape";
import { $planes, $selectedId, selectPlane } from "../store";
import type { LivePlane } from "../types";

export function renderRealtime(host: HTMLElement) {
  host.innerHTML = `
    <div class="card realtime">
      <div class="head">
        <div class="l">
          <i class="ph-fill ph-cell-tower" style="color:var(--muted)"></i>
          <span class="title">REALTIME</span>
          <span class="sub">ADS-B</span>
        </div>
        <div class="r">
          <span style="display:flex;align-items:center;gap:6px;font-size:var(--fs-sm);font-weight:700;color:var(--text)">
            <i class="ph-fill ph-airplane" style="font-size:var(--fs-sm);color:var(--muted)"></i><b id="rtCount">0</b>
          </span>
          <i class="ph ph-gear"></i>
        </div>
      </div>
      <div class="divider"></div>
      <div class="table">
        <div class="colhead">
          <span></span><span>Callsign</span><span>Spd</span><span>Alt</span><span>Ctry</span><span>Sq</span>
        </div>
        <div class="scroll" id="rtBody"></div>
      </div>
    </div>
  `;

  const body = host.querySelector("#rtBody") as HTMLElement;
  const countEl = host.querySelector("#rtCount") as HTMLElement;

  function row(p: LivePlane) {
    const active = $selectedId.get() === p.id;
    // p.id/call/ctry/squawk come verbatim from the ADS-B feed (dump1090
    // aircraft.json) — escape for both attribute (data-id) and body contexts.
    return `
      <div class="row ${active ? "active" : ""}" data-id="${escapeHtml(p.id)}">
        <i class="ph-fill ph-airplane ico"></i>
        <div class="call"><b>${escapeHtml(p.call)}</b></div>
        <div class="num">${Math.round(p.spd)}</div>
        <div class="num">${p.alt.toLocaleString()}</div>
        <div class="ctry">${escapeHtml(p.ctry ?? "—")}</div>
        <div class="ident">${escapeHtml(p.squawk ?? "—")}</div>
      </div>`;
  }

  function render() {
    const planes = Object.values($planes.get()).sort((a, b) => a.call.localeCompare(b.call));
    countEl.textContent = String(planes.length);
    if (planes.length === 0) {
      body.innerHTML = `<div class="empty">No aircraft tracked.</div>`;
      return;
    }
    body.innerHTML = planes.map(row).join("");
  }

  body.addEventListener("click", (e) => {
    const row = (e.target as HTMLElement).closest("[data-id]") as HTMLElement | null;
    if (row) selectPlane(row.dataset.id ?? null);
  });

  $planes.subscribe(render);
  $selectedId.subscribe(render);
}
